import { useLocale } from "@/hooks/useLocale";
import { useEffect, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { Button, Container, Form, Stack } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { placeholders } from "@/data/placeholders";
import Search from "@/assets/Search.svg";
import { events_helper } from "@/helpers/events_helper";

export const EventsPageSearchWidget = ({ className, onSubmit }) => {
  const locale = useLocale();
  const [tagOptions] = useState(events_helper.fetchTags());
  const [visible, setVisible] = useState(false);
  const [ready, setReady] = useState(false);
  const [query, setQuery] = useState("");
  const [tag, setTag] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setReady(true);
    }, 1500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({ query, tag });
  };

  return (
    <VisibilitySensor onChange={() => setVisible(true)}>
      <Form onSubmit={handleSubmit} className={clsx(className, classes.widget, { visible, loading: !ready })}>
        <Container className="px-2 px-md-3">
          <Stack className={clsx(classes.widget__wrapper, "flex-column flex-sm-row")} gap={{ xs: 1, md: 3 }}>
            <Form.Group className="flex-grow-1">
              <Form.Label htmlFor="query" className="mb-0">
                <DynamicText path={`widget.event.search.query.label.${locale}`} />
              </Form.Label>
              <Form.Control
                value={query}
                id="query"
                type="text"
                onChange={(e) => setQuery(e.target.value)}
                placeholder={placeholders[`widget.event.search.placeholder.${locale}`]}
              />
            </Form.Group>
            <Form.Group className="mb-2 mb-md-0 me-sm-3 me-md-5">
              <Form.Label htmlFor="radius" className="mb-0">
                <DynamicText path={`widget.event.search.tag.label.${locale}`} />
              </Form.Label>
              <Form.Select className="form-select" value={tag} onChange={(e) => setTag(e.target.value)} id="radius">
                <option value="">{placeholders[`widget.event.tags.placeholder.${locale}`]}</option>
                {tagOptions.map((t, k) => (
                  <option key={k} value={t}>
                    {t}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Button
              variant="primary"
              className="px-4 d-flex flex-row justify-content-center align-items-center"
              onClick={handleSubmit}
            >
              <DynamicText path={`widget.event.search.button.${locale}`} tag="span" className="me-2" />
              <Search className="flex-shrink-0" />
            </Button>
          </Stack>
        </Container>
      </Form>
    </VisibilitySensor>
  );
};
